import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import GeofenceMap from 'src/components/administration/geofence-calculation/components/geofence-map';
import GeofenceCalculationItems from 'src/components/administration/geofence-calculation/components/geofence-calculation-items';
import { Entities } from 'src/common';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { MenuItem } from 'material-ui';
import { List, makeSelectable } from 'material-ui/List';
import SelectField from 'material-ui/SelectField';
import CircularProgress from 'material-ui/CircularProgress';

let SelectableList = makeSelectable(List);

class GeofenceCalculationAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            activeGeofence: [],
            startedFetching: false,
            selectedCountryCalc: null,
        };
    }

    componentWillMount() {
        this.setState({ startedFetching: true });
        const { selectedCompany } = this.props;

        this.props.fetchOwnBusCompany(selectedCompany);
        this.props.fetchByCompanyId(Entities.COUNTRY_CALCULATION, selectedCompany);

        this.props.search(Entities.GEOFENCE_AREA, `get-all`, 0, undefined, true);
    }

    setActiveGeofenceBoundary(boundaries) {
        this.setState({ activeGeofence: boundaries });
    }

    componentDidMount() {
        this.waitForGoogle();
    }

    waitForGoogle() {
        if (window.google && window.google.maps) {
            this.setState({ googleReady: true });
            return;
        }
        this.pollGoogle();
    }

    pollGoogle() {
        const interval = setInterval(() => {
            if (window.google && window.google.maps) {
                clearInterval(interval);
                this.setState({ googleReady: true });
            }
        }, 100);
    }

    render() {
        const { geofenceCalculations, geofenceAreas, countryCalculations, t, busCompany } = this.props;
        const location = busCompany && busCompany.entity && busCompany.entity.location;
        const lat = location ? location.lat : undefined;
        const lng = location ? location.lng : undefined;
        const centerMap = lat !== undefined && lng !== undefined ? { lat, lng } : null;
        const finishFetching =
            this.state.startedFetching &&
            !geofenceAreas.isFetching &&
            !geofenceCalculations.isFetching &&
            !countryCalculations.isFetching;
        if (!finishFetching) return <CircularProgress />;

        return (
            <>
                <div className="row">
                    <div className="col-md-8">
                        {this.state.googleReady && (
                            <GeofenceMap
                                containerElement={<div style={{ height: `350px`, width: '100%' }} />}
                                mapElement={<div style={{ height: `100%` }} />}
                                loadingElement={<div style={{ height: `100%` }} />}
                                activeGeofence={this.state.activeGeofence}
                                zoom={10}
                                center={centerMap}
                            />
                        )}
                    </div>
                    <div className="col-md-4">
                        <SelectField
                            value={this.state.selectedCountryCalc}
                            onChange={(event, index, item) => {
                                this.setState({
                                    selectedCountryCalc: item,
                                });
                                if (item.id)
                                    this.props.search(
                                        Entities.GEOFENCE_CALCULATIONS,
                                        `get-by-country-calculation/${item.id}`,
                                        0,
                                        undefined,
                                        true,
                                    );
                            }}
                            floatingLabelText={t('geofence.form.select_country_calc')}
                            fullWidth={true}
                            floatingLabelFixed={true}>
                            {countryCalculations.items.map(item => (
                                <MenuItem key={item.id} value={item} primaryText={item.name} />
                            ))}
                        </SelectField>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        {this.state.selectedCountryCalc !== null && (
                            <GeofenceCalculationItems
                                geofenceCalculations={geofenceCalculations.items}
                                geofenceAreas={geofenceAreas.items}
                                setActiveGeofenceBoundary={this.setActiveGeofenceBoundary}
                                countryCalculation={this.state.selectedCountryCalc}
                                t={t}
                                busCompany={this.props.busCompany}
                            />
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default withTranslation()(composeModalActions(GeofenceCalculationAdministration));
